import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import Constants from '../../submodules/logictry_config/constants';
import { AngleLeftIcon, AngleRightIcon } from '../../styledhtml/Icon';
import Scrollable from '../Scrollable';
import ScrollIt from '../../utils/Scroll';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Content = styled.div`
  position: relative;
  overflow: hidden;
  height: 34px;
  > div:last-child {
    transition: 0.5s all;
    opacity: 0;
  }
  :hover {
    > div:last-child {
      ${Constants.MediaDesktop} {
        opacity: 1;
      }
    }
  }
`;
const Topic = styled.div`
  cursor: pointer;
  min-width: 4rem;
  text-align: center;
  border-radius: 1.5rem;
  font-size: 0.75rem;
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  user-select: none;
`;
const Arrows = styled.div`
  > div {
    position: absolute;
    height: 34px;
    width: 60px;
    top: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    > div {
      border-radius: 50%;
      height: 1.5rem;
      width: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  > div:first-child {
    left: 0;
    background: linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
    justify-content: flex-start;
  }
  > div:last-child {
    right: 0;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
    justify-content: flex-end;
  }
`;

export default class FilterBar extends LogictryComponent {
  static propTypes = {
    allTopics: PropTypes.object,
    selectedTopics: PropTypes.array,
    onTopicSelected: PropTypes.func
  }
  state = {
    showLeft: false,
    showRight: false,
  }
  onScroll = () => {
    if (!this.topicsRef) return;
    const showLeft = this.topicsRef.scrollLeft > 0;
    const showRight = Math.ceil(this.topicsRef.scrollLeft + this.topicsRef.offsetWidth) < this.topicsRef.scrollWidth;
    this.setState({ showLeft, showRight });
  }
  scroll = (forward) => {
    if (!this.topicsRef) return;
    const destination = Math.max(this.topicsRef.scrollLeft + (forward ? this.topicsRef.offsetWidth : -this.topicsRef.offsetWidth), 0);
    ScrollIt(destination, this.topicsRef, undefined, undefined, undefined, true);
  }
  render() {
    const { allTopics, selectedTopics, onTopicSelected } = this.props;
    const { showLeft, showRight } = this.state;
    return (
      <Content
        onMouseEnter={this.onScroll}
      >
        <Scrollable
          horizontal
          onScroll={this.onScroll}
          scrollRef={(e) => { this.topicsRef = e; this.onScroll(); }}
          style={{ position: 'absolute', inset: 0 }}
          rememberScrollPosition={`filterbar`}
          hideScrollbar
        >
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            {Object.keys(allTopics).map((url) => {
              const isSelected = selectedTopics.includes(url);
              return (
                <Topic
                  key={url}
                  style={{ backgroundColor: isSelected ? Constants.DarkGray : Constants.MediumBackground, color: isSelected ? 'white' : 'unset', }}
                  onClick={() => {
                    onTopicSelected(url, this.topicsRef.scrollLeft)
                  }}
                >{allTopics[url]}</Topic>
              );
            })}
          </div>
        </Scrollable>
        <Arrows>
          <div style={{ display: showLeft && 'flex' || 'none' }}>
            <div onClick={() => this.scroll(false)}>
              <AngleLeftIcon style={{ width: 10, height: 10 }} />
            </div>
          </div>
          <div style={{ display: showRight && 'flex' || 'none' }}>
            <div onClick={() => this.scroll(true)}>
              <AngleRightIcon style={{ width: 10, height: 10 }} />
            </div>
          </div>
        </Arrows>
      </Content>
    );
  }
}



